import { createContext, useContext, useEffect } from 'react';

export const SUFFIXE_TITRE = 'Journal douane / accises';

/**
 * Le titre de l'onglet, **écrit à un seul endroit**.
 *
 * Hors du menu, un écran doit se nommer seul : « Historique » ne veut rien dire
 * dans une liste d'onglets, dans un favori, ni dans un lien collé à quelqu'un.
 * Le menu peut être court parce qu'il a son contexte autour ; l'onglet, non.
 *
 * La coquille déduit un titre de la route — c'est ce qui garantit qu'aucun écran
 * ne reste anonyme, même ceux qu'on ajoutera demain. Une page qui en sait plus
 * (le libellé d'un article, par exemple) l'annonce par ce hook, et la coquille
 * l'emporte alors sur le titre déduit.
 */
export const TitrePageContext = createContext<((titre: string | null) => void) | null>(null);

export function useTitrePage(titre: string | null): void {
  const annoncer = useContext(TitrePageContext);

  useEffect(() => {
    // Hors coquille — l'écran de connexion, le changement de mot de passe —
    // il n'y a personne pour relayer : la page écrit elle-même.
    if (!annoncer) {
      document.title = titre ? `${titre} — ${SUFFIXE_TITRE}` : SUFFIXE_TITRE;
      return () => {
        document.title = SUFFIXE_TITRE;
      };
    }

    annoncer(titre);
    return () => annoncer(null);
  }, [annoncer, titre]);
}
